import React from "react";

const Welcome = ()=>{
    return(
        <>
            <h1>Welcome page</h1>
        </>
    )
}

export default Welcome;